import React from "react";
import guide1 from "../../../New_Web_design/1_img.png";
import guide2 from "../../../New_Web_design/2_img.png";
import guide3 from "../../../New_Web_design/3_img.png";

export default function HowToInstallApp() {
  return (
    <div>
      <div style={{ backgroundColor: "#050810" }} className="p-3">
        <div className="container">
          <div
            className="d-flex "
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p
              className="header mb-0"
              style={{
                fontFamily: "NunitoBlack",

                color: "white",
              }}
            >
              Our Players
            </p>
          </div>
          <div
            className="d-flex"
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p
              className="sub-header"
              style={{
                color: "#929498",
                fontFamily: "JosefinSans",
              }}
            >
              Trust Wolfwin Game
            </p>
          </div>

          <div
            className="row mt-4 px-2 gx-2"
            style={{ display: "flex", justifyContent: "center" }}
          >
            {/* <div className="col-sm-12 col-md-6 col-lg-4 mt-4 ">
              <div>
                
                <p
                  className="sub-header mb-0 text-sm-start"
                  style={{
                    color: "#929498",
                    fontFamily: "JosefinSans",
                    fontSize: "25px",
                    textAlign: "center",
                  }}
                >
                  Step 01
                </p>
              </div>
              <div style={{ width: "300px" }} className="howToInstallTextWidth">
                <p
                  className="text-sm-start"
                  style={{
                    fontFamily: "JosefinSans",
                    fontSize: "23px",
                    color: "#f9c130",
                    textAlign: "center",
                  }}
                >
                  <b>Press "ok" to complete the download</b>
                </p>
              </div>
              <div width="100%" height="70%">
                
                <img
                  src={guide1}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4 mt-4 ">
              <div>
                
                <p
                  className="sub-header mb-0 text-sm-start"
                  style={{
                    color: "#929498",
                    fontFamily: "JosefinSans",
                    fontSize: "25px",
                    textAlign: "center",
                  }}
                >
                  Step 02
                </p>
              </div>
              <div>
                <p
                  className="text-sm-start"
                  style={{
                    fontFamily: "JosefinSans",
                    fontSize: "23px",
                    color: "#f9c130",
                    textAlign: "center",
                  }}
                >
                  <b> Open "Settings" and turn on unknown sources to install</b>
                </p>
              </div>
              <div width="100%" height="70%">
                
                <img
                  src={guide2}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-4 mt-4 ">
              <div>
                
                <p
                  className="sub-header mb-0 text-sm-start"
                  style={{
                    color: "#929498",
                    fontFamily: "JosefinSans",
                    fontSize: "25px",
                    textAlign: "center",
                  }}
                >
                  Step 03
                </p>
              </div>
              <div style={{ width: "300px" }} className="howToInstallTextWidth">
                <p
                  className="text-sm-start"
                  style={{
                    fontFamily: "JosefinSans",
                    fontSize: "23px",
                    color: "#f9c130",
                    textAlign: "center",
                  }}
                >
                  <b> Press "ok" to complete the download</b>
                </p>
              </div>

              <div width="100%" height="70%">
                
                <img
                  src={guide3}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
                <div id="FAQ"></div>
              </div>
            </div> */}

            <div className="col-sm-12 col-md-6 col-lg-6 mt-4">
              <div
                className="p-4"
                style={{
                  border: "4px solid #919397",
                  borderRadius: "20px",
                  maxWidth: "560px",
                  width: "100%",
                  maxHeight: "415px",
                  height: "100%",
                }}
              >
                <iframe
                  style={{ height: "100%", width: "100%" }}
                  src="https://www.youtube.com/embed/TRi1gCYRPqM?si=LCNq2f7q-ftGEu1e"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 mt-4">
              <div
                className="p-4"
                style={{
                  border: "4px solid #919397",
                  borderRadius: "20px",
                  maxWidth: "560px",
                  width: "100%",
                  maxHeight: "415px",
                  height: "100%",
                }}
              >
                <iframe
                  style={{ height: "100%", width: "100%" }}
                  className="gameVideo"
                  src="https://www.youtube.com/embed/RR0EsOjF2ls?si=6jTy2kYL7vb8OQ3t"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
